/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class ViewportApi extends runtime.BaseAPI {
    /**
     * Create Viewport
     */
    async v2CreateViewportRaw(requestParameters, initOverrides) {
        if (requestParameters['tabId'] == null) {
            throw new runtime.RequiredError('tabId', 'Required parameter "tabId" was null or undefined when calling v2CreateViewport().');
        }
        if (requestParameters['viewportCreate'] == null) {
            throw new runtime.RequiredError('viewportCreate', 'Required parameter "viewportCreate" was null or undefined when calling v2CreateViewport().');
        }
        const queryParameters = {};
        if (requestParameters['tabId'] != null) {
            queryParameters['tab_id'] = requestParameters['tabId'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/viewport/`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['viewportCreate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create Viewport
     */
    async v2CreateViewport(requestParameters, initOverrides) {
        const response = await this.v2CreateViewportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete Viewport
     */
    async v2DeleteViewportRaw(requestParameters, initOverrides) {
        if (requestParameters['viewportId'] == null) {
            throw new runtime.RequiredError('viewportId', 'Required parameter "viewportId" was null or undefined when calling v2DeleteViewport().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/viewport/{viewport_id}`;
        urlPath = urlPath.replace(`{${"viewport_id"}}`, encodeURIComponent(String(requestParameters['viewportId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Delete Viewport
     */
    async v2DeleteViewport(requestParameters, initOverrides) {
        const response = await this.v2DeleteViewportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Tab Viewports
     */
    async v2GetTabViewportsRaw(requestParameters, initOverrides) {
        if (requestParameters['tabId'] == null) {
            throw new runtime.RequiredError('tabId', 'Required parameter "tabId" was null or undefined when calling v2GetTabViewports().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/viewport/tab/{tab_id}`;
        urlPath = urlPath.replace(`{${"tab_id"}}`, encodeURIComponent(String(requestParameters['tabId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get Tab Viewports
     */
    async v2GetTabViewports(requestParameters, initOverrides) {
        const response = await this.v2GetTabViewportsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Viewport
     */
    async v2GetViewportRaw(requestParameters, initOverrides) {
        if (requestParameters['viewportId'] == null) {
            throw new runtime.RequiredError('viewportId', 'Required parameter "viewportId" was null or undefined when calling v2GetViewport().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/viewport/{viewport_id}`;
        urlPath = urlPath.replace(`{${"viewport_id"}}`, encodeURIComponent(String(requestParameters['viewportId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get Viewport
     */
    async v2GetViewport(requestParameters, initOverrides) {
        const response = await this.v2GetViewportRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update Viewport
     */
    async v2UpdateViewportRaw(requestParameters, initOverrides) {
        if (requestParameters['viewportId'] == null) {
            throw new runtime.RequiredError('viewportId', 'Required parameter "viewportId" was null or undefined when calling v2UpdateViewport().');
        }
        if (requestParameters['viewportUpdate'] == null) {
            throw new runtime.RequiredError('viewportUpdate', 'Required parameter "viewportUpdate" was null or undefined when calling v2UpdateViewport().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/viewport/{viewport_id}`;
        urlPath = urlPath.replace(`{${"viewport_id"}}`, encodeURIComponent(String(requestParameters['viewportId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['viewportUpdate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Update Viewport
     */
    async v2UpdateViewport(requestParameters, initOverrides) {
        const response = await this.v2UpdateViewportRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
